import moment from 'moment';
import { useState } from 'react';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

import TooltipDark from '../../../../kakapo-ui-kit/components/tooltips/TooltipDark';

const Container = styled.div`
	width: 36px;
	position: relative;

	&,
	* {
		cursor: default;
	}
`;

const CalendarIconMonth = styled.p`
	color: ${tokens.text.inverse};
	background-color: ${tokens.error.icon};
	border-radius: ${tokens.radius.xs}px ${tokens.radius.xs}px 0 0;
	display: flex;
	font-size: 10px;
	align-items: center;
	justify-content: center;
	text-transform: uppercase;
	font-weight: ${tokens.typography.weights.semibold};
	padding: 2px 5px 0 5px;
	line-height: 14px;
`;

const CalendarIconDay = styled.p`
	color: ${tokens.text.primary};
	background-color: ${tokens.surface.white};
	display: flex;
	font-size: ${tokens.typography.sizes.h3}px;
	align-items: center;
	justify-content: center;
	border-radius: 0 0 ${tokens.radius.xs}px ${tokens.radius.xs}px;
	border: 1px solid ${tokens.border.default};
	border-top-width: 0;
`;

const CalendarIcon = ({ date }: { date: Date }) => {
	const [hover, setHover] = useState(false);

	return (
		<Container onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
			<TooltipDark isHovered={hover} direction="south">
				{moment(date).format('L')}
			</TooltipDark>
			<CalendarIconMonth>{moment(date).format('MMM')}</CalendarIconMonth>
			<CalendarIconDay>{moment(date).date()}</CalendarIconDay>
		</Container>
	);
};

export default CalendarIcon;
